import ChangePassword from "../../components/Password/ChangePassword";

const Password = () => {
  return <ChangePassword />;
};

export default Password;
